export default __webpack_public_path__ + "static/210512_更新完成_kr-8397739a04f06e667b77dfee6b4f7efa.webp";